import { useLocalSearchParams } from "expo-router";
import { RankingsView } from "../../../components/RankingsView";

export default function FastCatRankingsRest() {
  const { rest } = useLocalSearchParams<{ rest?: string | string[] }>();
  const segments = Array.isArray(rest) ? rest : rest ? String(rest).split("/") : [];
  return <RankingsView segments={segments} />;
}
